import { createReducer, PayloadAction } from '@reduxjs/toolkit';
import { showModal, hideModal } from 'actions/modal';

interface ModalState {
    type: string | null;
    props: Record<string, unknown>;
}

const initialState: ModalState = {
    type: null,
    props: {},
};

const handleShow = (state: ModalState, action: PayloadAction<ModalState>) => {
    state.type = action.payload.type;
    state.props = action.payload.props || {};
};

const handleClose = (state: ModalState) => {
    state.type = null;
    state.props = {};
};

export default createReducer(initialState, builder => {
    builder.addCase(showModal, handleShow).addCase(hideModal, handleClose);
});
